import React from 'react';
import PropTypes from 'prop-types';

import { formatMoney } from '../format';

import { getCurrencyIcon } from '../../../../shared/js/get-currency-icon';

function getSign(amount) {
	return amount ? (amount > 0 ? '+' : '−') : '';
}

function MoneyAmountWithCurrency({ className, component, showSign, amount, keepDecimals, currency }) {
	const Component = component;
	const money = formatMoney(showSign ? Math.abs(amount) : amount, keepDecimals);

	return (
		<Component className={className}>
			{showSign && getSign(+amount)}{money} {getCurrencyIcon(currency)}
		</Component>
	);
}

MoneyAmountWithCurrency.defaultProps = {
	component: 'span',
	showSign: false,
	amount: 0,
	keepDecimals: true
};

MoneyAmountWithCurrency.propTypes = {
	className: PropTypes.string,
	component: PropTypes.string,
	showSign: PropTypes.bool,
	amount: PropTypes.any.isRequired,
	keepDecimals: PropTypes.bool.isRequired,
	currency: PropTypes.string.isRequired
};

export default MoneyAmountWithCurrency;


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/money/money-amount-with-currency.js